import { useQuery } from '@tanstack/react-query';
import { getIntakeEventsCount } from '@/api/requests/intakeEvent';

const useOpenEventsCount = () => useQuery({
  queryKey: ['intakeEvent', 'openCount'],
  queryFn: () => getIntakeEventsCount({ query: { status: 'open' } }),
  refetchInterval: 30000,
  select: (data) => data?.count ?? 0,
});

export default useOpenEventsCount;
